export const DURATION_UNITS = [
  { value: "giorni", label: "Giorni" },
  { value: "settimane", label: "Settimane" },
  { value: "mesi", label: "Mesi" },
];

const toISO = (d) => {
  const x = new Date(d);
  if (isNaN(x.getTime())) return "";
  return x.toISOString().slice(0, 10);
};

// Compute an end date (ISO) from a start date + duration value/unit.
export function computeEnd(startISO, value, unit) {
  if (!startISO) return "";
  const start = new Date(startISO);
  if (isNaN(start.getTime())) return "";
  const v = parseInt(value, 10) || 0;
  if (!v) return "";
  const end = new Date(start);
  if (unit === "giorni") end.setDate(end.getDate() + v);
  else if (unit === "mesi") end.setMonth(end.getMonth() + v);
  else end.setDate(end.getDate() + v * 7);
  return toISO(end);
}

export function planInfo(patient) {
  const plan = patient && patient.plan;
  if (!plan || !plan.start) return { hasPlan: false };
  const start = new Date(plan.start);
  if (isNaN(start.getTime())) return { hasPlan: false };

  let end = null;
  if (plan.end) {
    const e = new Date(plan.end);
    if (!isNaN(e.getTime())) end = e;
  }
  if (!end && plan.value) {
    const iso = computeEnd(plan.start, plan.value, plan.unit);
    if (iso) end = new Date(iso);
  }
  if (!end) return { hasPlan: false };

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const e = new Date(end);
  e.setHours(0, 0, 0, 0);
  const daysLeft = Math.round((e - today) / 86400000);
  return { hasPlan: true, start, end, daysLeft, expired: daysLeft < 0, expiringSoon: daysLeft <= 14 };
}
